module.exports = __webpack_public_path__ + "img/hz_35.067ec9a0.jpg";